import { ICountry } from "./authInterface";

export interface ICustomerServiceStore {
    getWorkingHours: (countries: ICountry[]) => void;
    workingHours: CustomerServiceDay[];
    loading: boolean;
    updateWorkingHours: (data: CustomerServiceDay[]) => void;
}

export interface CustomerServiceDay {
    id?: number;
    createdAt?: Date;
    updatedAt?: Date;
    day: WeekDays;
    isOpen?: boolean;
    startTime?: string | null;
    endTime?: string | null;
}

export enum WeekDays {
    SATURDAY = 'Saturday',
    SUNDAY = 'Sunday',
    MONDAY = 'Monday',
    TUESDAY = 'Tuesday',
    WEDNESDAY = 'Wednesday',
    THURSDAY = 'Thursday',
    FRIDAY = 'Friday',    
}

export enum TimeEdge {
    START_TIME = 'startTime',
    END_TIME = 'endTime',
}